exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".zui-logo{width:.78125rem;height:.520833rem;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/px2rem-webpack-loader?{"baseDpr":1,"remUnit":192,"remPrecision":6,"forcePxComment":"px","keepComment":"no","remLimit":1,"exclude":{}}!./src/components/less/logo.css
// module id = 936
// module chunks = 0